(function () {
  const devicesSliders = document.querySelectorAll('[data-selector="devices-slider"]');

  devicesSliders.forEach((sliderEl) => {
    const paginationEl = sliderEl.querySelector('.swiper-pagination');
    const nextEl = sliderEl.querySelector('.swiper-button-next');
    const prevEl = sliderEl.querySelector('.swiper-button-prev');

    if (!paginationEl || !nextEl || !prevEl) return;

    new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: false, 
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        767: {
          spaceBetween: 42,
        },
      },
    });
  });
})();



